export default __webpack_public_path__ + "static/media/skills.9126fe3f.png";